import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { getData } from '../../../services/auth';
import api from '../../../services/api';
// import { format } from 'date-fns';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import {
  MDBContainer,
  MDBIcon,
  MDBRow,
  MDBBtn,
  MDBCollapse,
  MDBCol,
  MDBSpinner,
} from 'mdbreact';
import NavBar from '../../../components/NavBar'; 
import Paginacao from '../../../components/Paginacao';

import resolverMensagemErro from '../../../utils/resolverMensagemErro';
import { toast } from 'react-toastify';
// 'AAAA-MM-DD' (DATEONLY) -> 'DD/MM/AAAA', sem passar por Date (fuso)
const dataBR = iso =>
  /^\d{4}-\d{2}-\d{2}/.test(iso || '')
    ? iso.slice(0, 10).split('-').reverse().join('/')
    : '';
// #35: colunas extras opcionais no export (label -> extrator do usuário)
const COLUNAS_EXTRAS = {
  'Nome social': u => u.nome_social || '',
  Gênero: u => u.genero || '',
  'Data de nascimento': u => u.data_nascimento || '',
  'Tipo sanguíneo': u => u.tipo_sanguineo || '',
  Órgão: u => u.adidos?.[0]?.orgao?.nome || '',
  Função: u =>
    (u.vaga_usuarios || []).find(v => v.vaga && v.vaga.funcao)?.vaga?.funcao
      ?.nome || '',
  // #387: ciclo funcional mais recente, calculado no backend (cicloFuncional)
  'Data de admissão': u => dataBR(u.admissao?.data),
  'DO admissão': u => u.admissao?.diario_oficial || '',
  'Data de exoneração': u => dataBR(u.exoneracao?.data),
  'DO exoneração': u => u.exoneracao?.diario_oficial || '',
};
const OPCOES_COLUNAS_EXTRAS = Object.keys(COLUNAS_EXTRAS).map(k => ({
  value: k,
  label: k,
}));

function Usuarios() {
  
  const [usuarios, setUsuarios] = useState([]);
  const [colunasExtras, setColunasExtras] = useState([]); // #35 export
  const [exportMenuOpen, setExportMenuOpen] = useState(false); // #35: menu de export c/ colunas
  const exportRef = useRef(null);
  const [collapseFiltro, setCollapseFiltro] = useState(false);

  // #35: fecha o menu de export ao clicar fora
  useEffect(() => {
    if (!exportMenuOpen) return undefined;
    const onDown = e => {
      if (exportRef.current && !exportRef.current.contains(e.target)) {
        setExportMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [exportMenuOpen]);

  // #35: marca/desmarca uma coluna extra do export
  const toggleColunaExtra = key => {
    setColunasExtras(prev =>
      prev.some(c => c.value === key)
        ? prev.filter(c => c.value !== key)
        : [...prev, { value: key, label: key }]
    );
  };

  const [linhas, setLinhas] = useState('');

  const [search, setSearch] = useState('');
  const [pagina, setPagina] = useState('1');
  const [qtd, setQtd] = useState('20');

  const [orgaos, setOrgaos] = useState([]);
  const [titulos, setTitulos] = useState([]);

  // ativo=true por default, espelhando a listagem inicial (so ativos) —
  // o Select de Ativo nasce preenchido com "Sim" e o export herda o filtro
  const [adSearch, setAdSearch] = useState({ ativo: true });
  const [gerencias, setGerencias] = useState();
  const [escala, setEscala] = useState([]);
  const [ala, setAla] = useState([]);

  const [loading, setLoading] = useState(false);


  const [botaoRelatorio, setBotaoRelatorio] = useState(false);

  const prevPage = async () => {
    if (pagina === 1) return;
    const backP = Number(pagina) - 1;
    await setPagina(backP);
    // list(backP);
  };

  const loadPermissao = async () => {
    // #116: /verifica-funcao passou a responder com status de erro quando a
    // consulta falha (antes devolvia o objeto de erro com 200). Como e GET, o
    // interceptor nao toasta — sem o catch, a excecao interromperia o restante
    // do carregamento da tela. Na falha, assume o modo mais restritivo.
    let botao;
    try {
      botao = await api.get('/verifica-funcao', {
        params: {
          rota: 'sem rota',
          tipo: 'efetivo',
        },
      });
    } catch (error) {
      setBotaoRelatorio(false);
      return;
    }

    if (botao.data === null) {
      setBotaoRelatorio(false);
    } else {
      setBotaoRelatorio(true);
    }
  };

  const nextPage = async () => {
    if (Number(pagina) + 1 > Math.ceil(Number(linhas) / Number(qtd))) return;
    const nextP = Number(pagina) + 1;
    await setPagina(nextP);
    // list(nextP);
  };

  const carregaOrgaos = async () => {
    const response = await api.get('/orgao', {});
    let dados = [];
    response.data.map(row => {
      return dados.push({ value: row.id, label: row.nome });
    });

    setOrgaos(dados);
  };

  const exportCSV = user => {
    const dados = [];

    user.map(usuario => {
      const linha = {
        nome: `${usuario.nome} ${usuario.sobrenome}`,
        cpf: '=""' + usuario.cpf + '""',
        rg: '=""' + usuario.rg + '""',
        id_funcional: '=""' + usuario.id_funcional + '""',
        telefone: usuario.telefone,
        email: usuario.email,
        cnh: '=""' + usuario.cnh + '""',
        ativo: usuario.ativo === true ? 'Nomeado' : 'Exonerado',
        cnh_categoria: usuario.cnh_categoria,
        cnh_validade: usuario.cnh_validade === null ? '' : usuario.cnh_validade,
        // : format(new Date(usuario.cnh_validade), 'dd/MM/yyyy'), // dia / mes / ano
        posto: usuario.lotacao.gerencia.sigla,
        ala: usuario.lotacao.ala.nome,
        adido:
          usuario.adidos.length === 0
            ? 'Agente Civil'
            : usuario?.adidos[0]?.orgao?.sigla,
        titulo:
          usuario.adidos.length === 0
            ? 'Agente Civil'
            : usuario?.adidos[0]?.titulo?.nome,
      };
      // #35: acrescenta as colunas extras escolhidas
      colunasExtras.forEach(c => {
        linha[c.value] = COLUNAS_EXTRAS[c.value](usuario);
      });
      return dados.push(linha);
    });
    return dados;
    // setDadosCSV(dados);
  };

  // versao "limpa" dos dados (sem o truque =""..."" usado so no CSV/Excel),
  // usada para XLSX e PDF. Mesmas colunas do CSV.
  const montaDadosRelatorio = user => {
    const extras = colunasExtras.map(c => c.value);
    return (user || []).map(usuario => {
      const linha = {
        Nome: `${usuario.nome} ${usuario.sobrenome}`,
        CPF: usuario.cpf || '',
        RG: usuario.rg || '',
        'Id Funcional': usuario.id_funcional || '',
        Telefone: usuario.telefone || '',
        Email: usuario.email || '',
        CNH: usuario.cnh || '',
        Status: usuario.ativo === true ? 'Nomeado' : 'Exonerado',
        'Categoria CNH': usuario.cnh_categoria || '',
        'Validade CNH':
          usuario.cnh_validade === null ? '' : usuario.cnh_validade,
        Posto: usuario.lotacao?.gerencia?.sigla || '',
        Ala: usuario.lotacao?.ala?.nome || '',
        Adido:
          usuario.adidos?.length === 0
            ? 'Agente Civil'
            : usuario?.adidos?.[0]?.orgao?.sigla || '',
        Titulo:
          usuario.adidos?.length === 0
            ? 'Agente Civil'
            : usuario?.adidos?.[0]?.titulo?.nome || '',
      };
      // #35: acrescenta as colunas extras escolhidas
      extras.forEach(col => {
        linha[col] = COLUNAS_EXTRAS[col](usuario);
      });
      return linha;
    });
  };

  // exporta Excel (.xlsx) via SheetJS
  const exportXLSX = user => {
    const dados = montaDadosRelatorio(user);
    if (dados.length === 0) return;
    const ws = XLSX.utils.json_to_sheet(dados);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Usuarios');
    XLSX.writeFile(wb, 'usuarios.xlsx');
  };

  // exporta PDF via jsPDF + autotable (paisagem, cabe mais colunas)
  const exportPDF = user => {
    const dados = montaDadosRelatorio(user);
    if (dados.length === 0) return;
    const colunas = Object.keys(dados[0]);
    const linhas = dados.map(d => colunas.map(c => d[c]));
    const doc = new jsPDF({ orientation: 'landscape' });
    doc.text('Relatório de Usuários', 14, 12);
    doc.autoTable({
      head: [colunas],
      body: linhas,
      startY: 18,
      styles: { fontSize: 7 },
      headStyles: { fillColor: [76, 99, 141] },
    });
    doc.save('usuarios.pdf');
  };

  // exporta CSV (mantem o formato atual: separador ; e truque ="" para
  // preservar zeros a esquerda em cpf/rg/cnh/id_funcional no Excel)
  const exportCSVArquivo = user => {
    const dados = exportCSV(user);
    if (dados.length === 0) return;
    const colunas = Object.keys(dados[0]);
    const linhas = dados.map(d => colunas.map(c => `"${d[c] ?? ''}"`).join(';'));
    const conteudo = [colunas.join(';'), ...linhas].join('\n');
    const blob = new Blob(['﻿' + conteudo], {
      type: 'text/csv;charset=utf-8;',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'usuarios.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  // busca o relatorio e exporta no formato escolhido (csv | pdf | xlsx),
  // respeitando os filtros avancados E a busca por texto da tela
  const exportarRelatorio = async formato => {
    try {
      const t = await api.get('/usuario-relatorio', {
        params: { ...adSearch, search },
      });
      const lista = t.data.rows || t.data || [];
      if (formato === 'pdf') exportPDF(lista);
      else if (formato === 'xlsx') exportXLSX(lista);
      else exportCSVArquivo(lista);
    } catch (e) {
      // silencioso: falha de rede/relatorio
    }
  };

  const carregaTitulos = async idOrgao => {
    const response = await api.get('/titulo', {
      params: {
        orgao_id: idOrgao,
      },
    });
    let dados = [];
    response.data.map(row => {
      return dados.push({ value: row.id, label: row.nome });
    });
    setTitulos(dados);

    // setLinhas(response.data.count);
  };

  const carregaGerencias = async () => {
    const response = await api.get('/gerencia', {
      params: {
        estrutura_logica: getData().gerencia,
      },
    });
    let dados = [];
    response.data.map(row => {
      dados.push({
        value: row.id,
        logica: row.estrutura_logica,
        label: row.nome,
      });
    });

    setGerencias(dados);
  };

  const carregaEscalas = async () => {
    const response = await api.get('/filtra-escalas', {
      params: {
        gerencia_id: adSearch.gerencia_id,
      },
    });
    let dados = [];
    response.data.map(row => {
      return dados.push({ value: row.id, label: row.nome });
    });

    setEscala(dados);
  };

  const carregaAlas = async escala => {
    const response = await api.get('/filtra-alas', {
      params: {
        gerencia_id: adSearch.gerencia_id,
        escala: escala,
      },
    });
    let dados = [];
    response.data.map(row => {
      return dados.push({ value: row.id, label: row.nome });
    });
    setAla(dados);
  };

  const listar = async () => {
    setLoading(true);
    // [#217] O setLoading(false) fica no finally: sem ele, uma falha do GET
    // deixava o spinner girando para sempre e sem mensagem nenhuma.
    try {
      const response = await api.get('/usuario', {
        params: {
          // pagina: pagina,
          // qtd: qtd,
          search: search,
          // respeita o filtro de status (Ativo) tambem na busca por nome
          ativo: adSearch.ativo,
          // ...dadosModal,
          // adSearch,
          // sort,
          // typeSort,
        },
      });

      setUsuarios(response.data.rows);
      setLinhas(response.data.count);
    } catch (err) {
      toast.error(resolverMensagemErro(err));
    } finally {
      setLoading(false);
    }
  };

  // funcao da vaga ATUAL (dt_fim null) do usuario -> "Sigla - Nome".
  // fallback: se nao houver vaga vigente, usa a ultima vaga com funcao.
  const funcaoAtual = usuario => {
    const vagas = (usuario && usuario.vaga_usuarios) || [];
    const comFuncao = vagas.filter(v => v.vaga && v.vaga.funcao);
    if (comFuncao.length === 0) return '—';
    const atual = comFuncao.find(v => !v.dt_fim) || comFuncao[0];
    const f = atual.vaga.funcao;
    if (f.sigla && f.nome) return `${f.sigla} - ${f.nome}`;
    return f.sigla || f.nome || '—';
  };

  const listarFiltros = async () => {
    const response = await api.get('/usuario-filtro', {
      params: {
        ...adSearch,
        // #92: combina o texto de busca (nome) com os filtros avançados —
        // antes o search era descartado ao usar os filtros.
        search,
        // sort,
        // typeSort,
      },
      // order: [['nome']],
    });
    setUsuarios(response.data.rows);
    setLinhas(response.data.count);
  };
  // useEffect(() => {
  //   listar();
  //   carregaGerencias();
  // }, [pagina, qtd]);
  useEffect(() => {
    carregaGerencias();
    loadPermissao();
  }, []);

  useEffect(() => {
    if (adSearch.gerencia_id) {
      carregaEscalas();
    }
  }, [adSearch.gerencia_id]); // Removido carregaEscalas das dependências

  useEffect(() => {
    // Se o campo de pesquisa estiver vazio, listar imediatamente
    if (search.length === 0) {
      listar();
      return;
    }

    // Se houver texto, aguardar 1 segundo antes de listar
    const delayDebounceFn = setTimeout(() => {
      listar();
    }, 1000);

    // Limpa o timeout se o componente for desmontado ou se o 'search' mudar novamente
    return () => clearTimeout(delayDebounceFn);
  }, [search]); // Removido listar das dependências

  // useEffect(() => {
  //   // Cancela a busca anterior se o usuário continuar digitando
  //   const delayDebounceFn = setTimeout(() => {
  //     if (search.length > 2 || search.length === 0) {
  //       listar();
  //     }
  //   }, 3000); // Espera 3 segundos antes de executar

  //   return () => clearTimeout(delayDebounceFn); // Limpa o timeout se o componente for desmontado ou se o 'search' mudar novamente
  // }, [search]); // Executa novamente se 'search' mudar

  return (
    <>
      <NavBar>
        <MDBContainer fluid>
          <MDBRow
            style={{ borderRadius: '5px' }}
            className="flex-column-reverse flex-md-row justify-content-center align-items-center text-center"
          >
            <h3 className="h3-responsive  font-weight-bolder">
              Lista de Usuários
            </h3>
          </MDBRow>
        </MDBContainer>

        <MDBRow between className="md-form">
          <MDBCol col="12" md="3">
            {loading === true ? (
              <div className="d-flex justify-content-center align-items-center">
                <MDBSpinner />
                <div className="ml-3 d-flex align-items-center font-weight-bolder">
                  Carregando
                </div>
              </div>
            ) : (
              ''
            )}
          </MDBCol>

          <MDBCol
            className="d-flex justify-content-around align-items-center"
            col="12"
            md="5"
          >
            <input
              onChange={e => {
                setSearch(e.target.value);
              }}
              className="form-control ml-3 flex-1"
              type="text"
              placeholder="Pesquisar Usuário"
              aria-label="Search"
            />
          </MDBCol>
          <MDBCol
            className="d-flex align-items-center justify-content-center justify-content-md-end"
            col="12"
            md="4"
          >
            <MDBBtn
              color="mdb-color"
              onClick={() => setCollapseFiltro(!collapseFiltro)}
              className="d-flex justify-content-around align-items-center"
            >
              <MDBIcon icon="filter" size="1x" />
            </MDBBtn>

            {botaoRelatorio === false ? (
              ''
            ) : (
              <div ref={exportRef} style={{ position: 'relative' }}>
                <MDBBtn
                  color="mdb-color"
                  onClick={() => setExportMenuOpen(o => !o)}
                  className="lighten-1 white-text d-flex justify-content-around align-items-center"
                >
                  <MDBIcon fas icon="cloud-download-alt" size="1x" />
                  <span className="ml-2">Exportar</span>
                  <MDBIcon icon="caret-down" className="ml-2" />
                </MDBBtn>

                {exportMenuOpen && (
                  <div
                    className="card p-3 shadow"
                    style={{
                      position: 'absolute',
                      right: 0,
                      top: '100%',
                      zIndex: 1050,
                      minWidth: 260,
                      textAlign: 'left',
                    }}
                  >
                    <div className="small font-weight-bold text-uppercase grey-text mb-2">
                      Colunas extras
                    </div>
                    <div className="d-flex flex-wrap">
                      {OPCOES_COLUNAS_EXTRAS.map(op => {
                        const marcada = colunasExtras.some(
                          c => c.value === op.value
                        );
                        return (
                          <div
                            key={op.value}
                            onClick={() => toggleColunaExtra(op.value)}
                            className={`badge border p-2 mr-2 mb-2 d-flex align-items-center ${
                              marcada ? 'badge-primary' : 'badge-light'
                            }`}
                            style={{ cursor: 'pointer', fontSize: '0.78rem' }}
                          >
                            {marcada && (
                              <MDBIcon fas icon="check" className="mr-1" />
                            )}
                            {op.label}
                          </div>
                        );
                      })}
                    </div>
                    <hr className="my-2" />
                    <div className="d-flex justify-content-between">
                      <MDBBtn
                        size="sm"
                        color="success"
                        className="m-0 px-2"
                        onClick={() => {
                          exportarRelatorio('xlsx');
                          setExportMenuOpen(false);
                        }}
                      >
                        <MDBIcon fas icon="file-excel" className="mr-1" />
                        Excel
                      </MDBBtn>
                      <MDBBtn
                        size="sm"
                        color="danger"
                        className="m-0 px-2"
                        onClick={() => {
                          exportarRelatorio('pdf');
                          setExportMenuOpen(false);
                        }}
                      >
                        <MDBIcon fas icon="file-pdf" className="mr-1" />
                        PDF
                      </MDBBtn>
                      <MDBBtn
                        size="sm"
                        color="info"
                        className="m-0 px-2"
                        onClick={() => {
                          exportarRelatorio('csv');
                          setExportMenuOpen(false);
                        }}
                      >
                        <MDBIcon fas icon="file-csv" className="mr-1" />
                        CSV
                      </MDBBtn>
                    </div>
                  </div>
                )}
              </div>
            )}
          </MDBCol>
        </MDBRow>

        <MDBCollapse id="basicCollapse" isOpen={collapseFiltro}>
          <MDBRow className="rounded-top p-3 mr-1 ml-1 mt-1 mr-md-3 ml-md-3 justify-content-center text-center  bg-white">
            <MDBCol md="3" col="12">
              <Select
                className="text-left mb-2"
                placeholder="Gênero"
                options={[
                  { value: 'M', label: 'Masculino' },
                  { value: 'F', label: 'Feminino' },
                ]}
                isClearable={true}
                onChange={e => {
                  if (e === null) {
                    const { genero, ...resto } = adSearch;
                    setAdSearch(resto);
                    return;
                  }
                  setAdSearch({
                    ...adSearch,
                    genero: e.value,
                  });
                }}
              />
            </MDBCol>

            <MDBCol md="3" col="12">
              <Select
                className="text-left mb-2"
                placeholder="Ativo"
                defaultValue={{ value: true, label: 'Sim' }}
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                isClearable={true}
                onChange={e => {
                  if (e === null) {
                    const { ativo, ...resto } = adSearch;
                    setAdSearch(resto);
                    return;
                  }
                  setAdSearch({
                    ...adSearch,
                    ativo: e.value == null ? '' : e.value,
                  });
                }}
              />
            </MDBCol>

            <MDBCol md="3" col="12">
              <Select
                placeholder="Adido"
                className="text-left mb-2"
                options={[
                  { value: true, label: 'Sim' },
                  { value: false, label: 'Não' },
                ]}
                isClearable={true}
                onChange={e => {
                  if (e === null) {
                    const { adido, ...resto } = adSearch;
                    setAdSearch(resto);

                    return;
                  }
                  carregaOrgaos();
                  setAdSearch({
                    ...adSearch,
                    adido: e.value,
                  });
                }}
              />
              {adSearch.adido === true ? (
                <>
                  <Select
                    placeholder="Instituição"
                    className="text-left mb-2"
                    options={orgaos}
                    isClearable={true}
                    onChange={e => {
                      if (e === null) {
                        const { orgao, ...resto } = adSearch;
                        setAdSearch(resto);
                        return;
                      }
                      carregaTitulos(e.value);
                      setAdSearch({
                        ...adSearch,
                        orgao: e.value,
                      });
                    }}
                  />
                </>
              ) : (
                ''
              )}
            </MDBCol>
            <MDBCol md="3" col="12">
              <Select
                placeholder="Gerência"
                className="text-left mb-2"
                options={gerencias}
                isClearable={true}
                onChange={e => {
                  if (e === null) {
                    const {
                      gerencia_id,
                      gerencia_logica,
                      escala,
                      ala,
                      ...resto
                    } = adSearch;
                    setAdSearch(resto);
                    return;
                  }
                  setAdSearch({
                    ...adSearch,
                    gerencia_id: e.value,
                    gerencia_logica: e.logica,
                  });
                }}
              />

              {adSearch.gerencia_id ? (
                <Select
                  md="3"
                  col="12"
                  placeholder="Escala"
                  className="text-left mb-2"
                  options={escala}
                  isClearable={true}
                  onChange={e => {
                    if (e === null) {
                      const { escala, ala, ...resto } = adSearch;
                      setAdSearch(resto);
                      return;
                    }

                    carregaAlas(e.value);
                    setAdSearch({
                      ...adSearch,
                      escala: e.value,
                    });
                  }}
                />
              ) : (
                ''
              )}
              {adSearch.escala ? (
                <Select
                  md="3"
                  col="12"
                  placeholder="Ala"
                  className="text-left mb-2"
                  options={ala}
                  isClearable={true}
                  onChange={e => {
                    if (e === null) {
                      const { ala, ...resto } = adSearch;
                      setAdSearch(resto);
                      return;
                    }
                    setAdSearch({
                      ...adSearch,
                      ala: e.value,
                    });
                  }}
                />
              ) : (
                ''
              )}
            </MDBCol>
          </MDBRow>
          <MDBRow className="rounded-bottom p-3 mr-1 ml-1 mr-md-3 ml-md-3 justify-content-center text-center  bg-white">
            <MDBBtn
              color="mdb-color"
              onClick={listarFiltros}
              className=" d-flex justify-content-around align-items-center "
            >
              Buscar
            </MDBBtn>
          </MDBRow>
        </MDBCollapse>

        <MDBRow className="d-flex justify-content-end mx-4">
          <div className="font-weight-bold">
            Total:
            <span className="ml-1">
              {!usuarios.length ? (usuarios.length = 0) : usuarios.length}
            </span>
          </div>
        </MDBRow>
        <MDBRow
          between
          style={{ backgroundColor: 'rgba(250,250,250,0.8)' }}
          className="mx-3 p-2 d-none font-weight-bold d-md-flex rounded-top"
        >
          <div className="col-12 col-md-1 ">Status</div>
          <div className="col-12 col-md-3 ">Nome</div>
          <div className="col-12 col-md-2 ">Lotação</div>
          <div className="col-12 col-md-2 ">Função</div>
          <div className="col-12 col-md-2 ">Adido</div>
          <div className="col-12 col-md-2 text-right" />
        </MDBRow>

        {usuarios.map(t => (
          <div key={t.id}>
            <MDBRow
              style={{ borderTop: '1px solid silver' }}
              between
              className="p-2 mr-1 ml-1 mr-md-3 ml-md-3  bg-white"
            >
              <div className="col-12 col-md-1 d-flex justify-content-between">
                <span className="d-sm-inline d-md-none mr-3">Status:</span>
                <span>
                  {t.ativo === true ? (
                    <MDBIcon className="text-success" far icon="check-circle" />
                  ) : (
                    <MDBIcon className="text-danger" far icon="times-circle" />
                  )}
                </span>
              </div>

              <div className="col-12 col-md-3 d-flex justify-content-between">
                <span className="d-sm-inline d-md-none mr-3">Nome:</span>
                <span>{`${t.nome} ${t.sobrenome}`}</span>
              </div>
              <div className="col-12 col-md-2 d-flex justify-content-between">
                <span className="d-sm-inline d-md-none mr-3">Lotação:</span>
                {`${t.lotacao.gerencia.sigla} /${t.lotacao.escala.nome} /${t.lotacao.ala.nome}`}
              </div>
              <div className="col-12 col-md-2 d-flex justify-content-between">
                <span className="d-sm-inline d-md-none mr-3">Função:</span>
                {funcaoAtual(t)}
              </div>
              <div className="col-12 col-md-2 d-flex justify-content-between">
                <span className="d-sm-inline d-md-none mr-3">Adido:</span>
                {t.adidos.length === 0 ? (
                  'Agente Civil'
                ) : (
                  <div className="font-weight-bolder">{`${t?.adidos[0]?.orgao?.sigla} - ${t?.adidos[0]?.titulo?.nome}`}</div>
                )}
              </div>

              <div className="col-12 col-md-2 d-flex font-weight-bold justify-content-center justify-content-md-end">
                {getData().id === t.id ? (
                  ''
                ) : (
                  <Link to={`/usuarios/${t.id}`} className="blue-grey-text">
                    <MDBIcon
                      className="mr-1 "
                      far
                      icon="fas fa-eye"
                      size="1x"
                    />

                    <span>Visualizar</span>
                  </Link>
                )}
              </div>
            </MDBRow>
          </div>
        ))}

        {/* <Paginacao page={1} qtdTotal={linhas} /> */}

        <br />
        <br />
      </NavBar>
    </>
  );
}

export default Usuarios;
